module.exports = __webpack_public_path__ + "static/media/whatsapp.94ca4e3c.svg";